import Dexie from "dexie";

export const db = new Dexie("OfflineFieldDB");

db.version(1).stores({
  pending_tasks: "++id, profil_no, status", // Mevcut tablo
  sondaj_verileri: "++id, sonda_no, job_id, status", // YENİ TABLO
});
